export const CSR = {
    FETCH_CSR: {
        MAIN: 'FETCH_CSR',
        SUCCESS: 'FETCH_CSR_SUCCESS',
        FAILURE: 'FETCH_CSR_FAILURE'
    }
};
